module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Relatórios de Execução\n        "), _vm._v(" "), (!_vm.loading.tela) ? _c('span', [(!_vm.ehVisualizacao && _vm.telaRelatorio.alerta.restricao !== 'ENVIO_BLOQUEADO') ? _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.permiteConcluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvaRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.print($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "title": '<h5>Faz o download de todos os arquivos (zip)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onDownloadZIP()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(" Baixar arquivos")])]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1) : _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Projetos',
        href: '/projetos/lista'
      }, {
        text: 'Relatório de Execuação',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (_vm.telaRelatorio.alerta.situacao !== 'OCULTO') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrar_msg),
      expression: "mostrar_msg"
    }],
    staticClass: "alert alert-dismissible alert-warning"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "fa fa fa-info"
  }), _vm._v("  " + _vm._s(_vm.telaRelatorio.alerta.titulo))]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.telaRelatorio.alerta.conteudo)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.aviso.situacao !== 'OCULTO') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrar_msg),
      expression: "mostrar_msg"
    }],
    staticClass: "alert alert-dismissible alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v("  " + _vm._s(_vm.telaRelatorio.aviso.titulo))]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.telaRelatorio.aviso.conteudo)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.tipoUsu === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "100px",
      "padding": "0px"
    }
  }, [_c('RelatorioBNDES', {
    key: _vm.componentKey,
    ref: "relatorioBNDESChildRef",
    attrs: {
      "dadosRelatorio": _vm.telaRelatorio,
      "previstoPublicoAlvo": _vm.previstoPublicoAlvo,
      "totalizadores": _vm.totalizadoresListaParticipantes,
      "executadasparcial": _vm.executadasparcial,
      "naoexecutadas": _vm.naoexecutadas,
      "contrapartida": _vm.telaRelatorio.contrapartida_comprovada.row
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 form-group required-field",
    class: {
      'has-error': _vm.errors.first('usuarioEnvioNome')
    }
  }, [_c('label', {
    staticClass: "col control-label"
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.usuario_enviou.nome),
      expression: "telaRelatorio.usuario_enviou.nome"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.first('usuarioEnvioNome')
    },
    attrs: {
      "disabled": true,
      "id": "usuarioEnvioNome",
      "name": "usuarioEnvioNome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.usuario_enviou.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.usuario_enviou, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('usuarioEnvioNome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Usuário que enviou é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 form-group required-field",
    class: {
      'has-error': _vm.errors.first('usuarioEnvioCPF')
    }
  }, [_c('label', {
    staticClass: "col control-label"
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.usuario_enviou.cpf),
      expression: "telaRelatorio.usuario_enviou.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['###.###.###-##']),
      expression: "['###.###.###-##']"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.first('usuarioEnvioCPF')
    },
    attrs: {
      "disabled": true,
      "id": "usuarioEnvioCPF",
      "name": "usuarioEnvioCPF",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.usuario_enviou.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.usuario_enviou, "cpf", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('usuarioEnvioCPF')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo CPF do usuário que enviou é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 form-group required-field",
    class: {
      'has-error': _vm.errors.first('usuarioEnvioEmail')
    }
  }, [_c('label', {
    staticClass: "col control-label"
  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.usuario_enviou.email),
      expression: "telaRelatorio.usuario_enviou.email"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.first('usuarioEnvioEmail')
    },
    attrs: {
      "disabled": true,
      "id": "usuarioEnvioEmail",
      "name": "usuarioEnvioEmail",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.usuario_enviou.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.usuario_enviou, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('usuarioEnvioEmail')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Email do usuário que enviou é obrigatório')))]) : _vm._e()])])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v("Nº do Projeto:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.numero_projeto),
      expression: "telaRelatorio.cabecalho.numero_projeto"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "id": "repNumber",
      "name": "repNumber",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.numero_projeto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "numero_projeto", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('label', {
    staticClass: "col"
  }, [_vm._v("Título do Projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.projeto),
      expression: "telaRelatorio.cabecalho.projeto"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "id": "repTitle",
      "name": "repTitle",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.projeto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "projeto", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col"
  }, [_vm._v("Início de execução do projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.inicio),
      expression: "telaRelatorio.cabecalho.inicio"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "id": "inicioProjeto",
      "name": "inicioProjeto",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.inicio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "inicio", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col"
  }, [_vm._v("Fim de execução do projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.termino),
      expression: "telaRelatorio.cabecalho.termino"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "id": "terminoProjeto",
      "name": "terminoProjeto",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.termino)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "termino", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col"
  }, [_vm._v("Percentual Financeiro Realizado:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.percentual_liberacao),
      expression: "telaRelatorio.cabecalho.percentual_liberacao"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "id": "percentualLiberacao",
      "name": "percentualLiberacao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.percentual_liberacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "percentual_liberacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col"
  }, [_vm._v("Percentual de tempo decorrido:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.percentual_andamento),
      expression: "telaRelatorio.cabecalho.percentual_andamento"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "id": "percentualAndamento",
      "name": "percentualAndamento",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.percentual_andamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "percentual_andamento", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col"
  }, [_vm._v("Convenente:")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.entidade),
      expression: "telaRelatorio.cabecalho.entidade"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "id": "contractor",
      "name": "contractor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.entidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "entidade", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-group required-field",
    class: {
      'has-error': _vm.errors.first('mail')
    }
  }, [_c('div', {
    staticClass: "col form-group required"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail de contato:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.email_contato),
      expression: "telaRelatorio.cabecalho.email_contato"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.first('mail')
    },
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "id": "mail",
      "name": "mail",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.email_contato)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "email_contato", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('mail')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('mail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-group required-field",
    class: {
      'has-error': _vm.errors.first('telefone1')
    }
  }, [_c('div', {
    staticClass: "col form-group required"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone 1:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.telefone_contato_1),
      expression: "telaRelatorio.cabecalho.telefone_contato_1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) ####-#####'),
      expression: "'(##) ####-#####'"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.first('telefone1')
    },
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "id": "telefone1",
      "masked": _vm.masked,
      "name": "telefone1",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.telefone_contato_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "telefone_contato_1", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('telefone1')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Telefone é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-group"
  }, [_c('div', {
    staticClass: "col form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone 2:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cabecalho.telefone_contato_2),
      expression: "telaRelatorio.cabecalho.telefone_contato_2"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) ####-#####'),
      expression: "'(##) ####-#####'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "id": "telefone2",
      "masked": _vm.masked,
      "name": "telefone2",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cabecalho.telefone_contato_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cabecalho, "telefone_contato_2", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col form-group required",
    class: {
      'has-error': _vm.errors.first('relFinal')
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v("É o relatório final do projeto?")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-2 form-group required",
    class: {
      'has-error': _vm.errors.first('relFinal')
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.tipo_relatorio),
      expression: "telaRelatorio.tipo_relatorio"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "relFinal",
      "value": "FINAL",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.tipo_relatorio, "FINAL")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio, "tipo_relatorio", "FINAL")
      }
    }
  }), _vm._v(" Sim\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.tipo_relatorio),
      expression: "telaRelatorio.tipo_relatorio"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "relFinal",
      "value": "PARCIAL",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.tipo_relatorio, "PARCIAL")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio, "tipo_relatorio", "PARCIAL")
      }
    }
  }), _vm._v(" Não\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.errors.first('relFinal')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Relatório final é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), (_vm.telaRelatorio.tipo_relatorio === 'FINAL') ? _c('div', {
    class: {
      'has-error': _vm.errors.first('objeto1')
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('label', {
    staticClass: "form-group control-label",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px",
      "font-size": "12px"
    }
  }, [_vm._v("Indicadores de Execução")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "indicadoresResultado"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.proposta.indicadores_resultado),
      callback: function($$v) {
        _vm.$set(_vm.proposta, "indicadores_resultado", $$v)
      },
      expression: "proposta.indicadores_resultado"
    }
  })], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-2 form-group required"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.objeto),
      expression: "telaRelatorio.objeto"
    }],
    attrs: {
      "type": "radio",
      "name": "objeto1",
      "value": "SIM"
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.objeto, "SIM")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio, "objeto", "SIM")
      }
    }
  }), _vm._v(" Sim\n                            "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.objeto),
      expression: "telaRelatorio.objeto"
    }],
    attrs: {
      "type": "radio",
      "name": "objeto1",
      "value": "NAO"
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.objeto, "NAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio, "objeto", "NAO")
      }
    }
  }), _vm._v(" Não\n                            "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), (_vm.telaRelatorio.objeto === 'NAO') ? _c('div', {
    staticClass: "col-md-6 form-group required-field",
    class: {
      'has-error': _vm.errors.first('justificativaObjeto')
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group required"
  }, [_c('label', {
    staticClass: "form-group control-label",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px",
      "font-size": "12px"
    }
  }, [_vm._v("Justifique")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.objetoJustificativa),
      expression: "telaRelatorio.objetoJustificativa"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.first('justificativaObjeto')
    },
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "name": "justificativaObjeto"
    },
    domProps: {
      "value": (_vm.telaRelatorio.objetoJustificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio, "objetoJustificativa", $event.target.value)
      }
    }
  })])]) : _vm._e()])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    ref: "metAtv",
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#F2F3F4"
    }
  }, _vm._l((_vm.headerTable.thead), function(head) {
    return _c('th', {
      attrs: {
        "colspan": 4
      }
    }, [_c('div', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(head.header))])])
  }), 0), _vm._v(" "), _c('tr', _vm._l((_vm.subArray), function(sub) {
    return _c('th', {
      attrs: {
        "width": sub.width
      }
    }, [_c('span', [_c('div', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(sub.title))])])])
  }), 0)]), _vm._v(" "), _vm._l((_vm.telaRelatorio.metas.row), function(data) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "rowspan": data.atividades.row.length + 1
      }
    }, [_vm._v(_vm._s(data.meta))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "rowspan": data.atividades.row.length + 1
      }
    }, [_vm._v(_vm._s(data.orcado))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "rowspan": data.atividades.row.length + 1
      }
    }, [_c('div', {
      staticClass: "col form-group required",
      class: {
        'has-error': _vm.errors.first('metaRealizado' + data.id)
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.realizado),
        expression: "data.realizado"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:0'),
        expression: "'required|min_value:0'"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.ehVisualizacao,
        "id": 'realizado' + data.id,
        "name": 'metaRealizado' + data.id,
        "type": "text"
      },
      domProps: {
        "value": (data.realizado)
      },
      on: {
        "keypress": _vm.onlyNumber,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(data, "realizado", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-append"
    }, [_vm._v(_vm._s(data.unidade))])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "rowspan": data.atividades.row.length + 1
      }
    }, [(data.orcado > 0) ? _c('div', [(parseInt(data.realizado) >= parseInt(data.orcado)) ? _c('span', [_vm._v("100 %")]) : (parseInt(data.realizado) < parseInt(data.orcado)) ? _c('span', [_vm._v(_vm._s(_vm._f("percentage")(parseInt(data.realizado) / parseInt(data.orcado))))]) : _vm._e(), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(data.realizado) < parseInt(data.orcado)),
        expression: "parseInt(data.realizado) < parseInt(data.orcado)"
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
      }],
      staticClass: "fa fa-exclamation fa-3",
      staticStyle: {
        "color": "blue",
        "margin-left": "10px",
        "font-size": "large",
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true",
        "title": '<h5>Necessário informar uma justificativa do não atigimento de meta.</h5>'
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(data.realizado) / parseInt(data.orcado) > 1),
        expression: "parseInt(data.realizado) / parseInt(data.orcado) > 1"
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
      }],
      staticClass: "fa fa-exclamation-triangle fa-3",
      staticStyle: {
        "color": "orange",
        "margin-left": "10px",
        "font-size": "large",
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true",
        "title": '<h5>Atentar que o valor realizado está maior do que o orçado para a referida Meta.</h5>'
      }
    })]) : _c('div', [_vm._v("0 %\n                        "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (parseInt(data.realizado) < parseInt(data.orcado)),
        expression: "parseInt(data.realizado) < parseInt(data.orcado)"
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
      }],
      staticClass: "fa fa-exclamation fa-3",
      staticStyle: {
        "color": "blue",
        "margin-left": "10px",
        "font-size": "large",
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true",
        "title": '<h5>Necessário informar uma justificativa do não atigimento de meta.</h5>'
      }
    })])])]), _vm._l((data.atividades.row), function(data2) {
      return _c('tr', [_c('td', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
        }],
        staticClass: "text-center",
        attrs: {
          "title": '<h5>Documentos comprobatórios: ' + data2.documento_comprobatorio + '</h5>'
        }
      }, [_vm._v(_vm._s(data2.atividade))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_c('div', {
        class: {
          'has-error': _vm.errors.first('data2.id')
        }
      }, [_c('div', {
        staticClass: "col form-group required",
        class: {
          'has-error': _vm.errors.first('atividadeStatus' + data2.id)
        }
      }, [_c('label', {
        staticClass: "radio-inline new-control new-control-radio"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (data2.status),
          expression: "data2.status"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "type": "radio",
          "name": 'atividadeStatus_meta' + data2.id + 'atvd' + data.id,
          "id": 'atvdStatus_meta' + data2.id + 'atvd' + data.id,
          "disabled": _vm.ehVisualizacao
        },
        domProps: {
          "value": 1,
          "checked": _vm._q(data2.status, 1)
        },
        on: {
          "change": [function($event) {
            return _vm.$set(data2, "status", 1)
          }, function($event) {
            return _vm.passaMetas2(data, data2)
          }]
        }
      }), _vm._v(" Executada\n                              "), _c('div', {
        staticClass: "new-control-indicator",
        staticStyle: {
          "top": "2px"
        }
      })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
        staticClass: "radio-inline new-control new-control-radio"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (data2.status),
          expression: "data2.status"
        }],
        attrs: {
          "type": "radio",
          "name": 'atividadeStatus_meta' + data2.id + 'atvd' + data.id,
          "id": 'execucao_meta' + data2.id + 'atvd' + data.id,
          "disabled": _vm.ehVisualizacao,
          "required": ""
        },
        domProps: {
          "value": 2,
          "checked": _vm._q(data2.status, 2)
        },
        on: {
          "change": [function($event) {
            return _vm.$set(data2, "status", 2)
          }, function($event) {
            return _vm.passaMetas3(data, data2)
          }]
        }
      }), _vm._v(" Em execução\n                            "), _c('div', {
        staticClass: "new-control-indicator",
        staticStyle: {
          "top": "2px"
        }
      })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
        staticClass: "radio-inline new-control new-control-radio"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (data2.status),
          expression: "data2.status"
        }],
        attrs: {
          "type": "radio",
          "name": 'atividadeStatus_meta' + data2.id + 'atvd' + data.id,
          "disabled": _vm.ehVisualizacao,
          "required": ""
        },
        domProps: {
          "value": 3,
          "checked": _vm._q(data2.status, 3)
        },
        on: {
          "change": [function($event) {
            return _vm.$set(data2, "status", 3)
          }, function($event) {
            return _vm.passaMetas(data, data2)
          }]
        }
      }), _vm._v(" Não executada\n                            "), _c('div', {
        staticClass: "new-control-indicator",
        staticStyle: {
          "top": "2px"
        }
      })]), _vm._v(" "), _c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (data2.status === 3),
          expression: "data2.status === 3"
        }, {
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
        }],
        staticClass: "fa fa-exclamation fa-3",
        staticStyle: {
          "color": "red",
          "margin-left": "10px",
          "font-size": "large",
          "cursor": "pointer"
        },
        attrs: {
          "aria-hidden": "true",
          "title": '<h5>Necessário informar uma justificativa da não execução da atividade.</h5>'
        }
      })])])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('div', {
        staticClass: "input-group mb-3",
        class: {
          'has-error': _vm.errors.first('execucao' + data.id)
        }
      }, [_c('div', {
        staticClass: "left"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (data2.execucao),
          expression: "data2.execucao"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0|max_value:100|numeric'),
          expression: "'required|min_value:0|max_value:100|numeric'"
        }],
        staticClass: "form-control",
        staticStyle: {
          "width": "65px"
        },
        attrs: {
          "type": "number",
          "min": "0",
          "max": "100",
          "disabled": _vm.ehVisualizacao || data2.execucao === 100 || data2.execucao === 0,
          "id": 'execucao_meta' + data2.id + 'atvd' + data.id,
          "maxlength": "3",
          "name": 'execucao_meta' + data2.id + 'atvd' + data.id,
          "data-vv-as": "percentual de execução"
        },
        domProps: {
          "value": (data2.execucao)
        },
        on: {
          "keypress": _vm.onlyNumber,
          "change": _vm.buscaAtividade,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(data2, "execucao", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "red"
        }
      }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('execucao_meta' + data2.id + 'atvd' + data.id)))])])]), _vm._v(" "), _c('span', {
        staticStyle: {
          "line-height": "35px"
        }
      }, [_vm._v("%")])])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('i', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
        }],
        staticClass: "glyphicon glyphicon-duplicate",
        staticStyle: {
          "font-size": "large",
          "cursor": "pointer"
        },
        style: ((data2.anexos_atividades.row.length === 0) ? _vm.colorFadeStyle : ''),
        attrs: {
          "aria-en": "true"
        },
        on: {
          "click": function($event) {
            return _vm.ativaDocumentos(data2)
          }
        }
      })])])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.ativarDocumentos) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    ref: "doc",
    staticClass: "box box-primary",
    attrs: {
      "name": "doc",
      "id": "doc"
    }
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Anexo de comprovação da atividade\n                        executada - " + _vm._s(_vm.documentosAtividade.atividade))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.ehVisualizacao) ? _c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.documentosAtividade.anexos_atividades.row,
      "documentTypes": '',
      "disable": 'true',
      "localUso": _vm.listaDocMetas,
      "salvouOK": _vm.salvouOK
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.documentosAtividade.anexos_atividades.row,
      "documentTypes": '',
      "disable": '',
      "localUso": _vm.listaDocMetas,
      "salvouOK": _vm.salvouOK
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "ng-if": "goalActExeRepCrtl.approval.status != 'REJECTED' && goalActExeRepCrtl.approval.status != 'APPROVED'"
    },
    on: {
      "click": function($event) {
        _vm.ativarDocumentos = false
      }
    }
  }, [_vm._v("Fechar")])])])])]) : _vm._e()]), _vm._v(" "), ((_vm.executadasparcial.length)) ? _c('table', {
    ref: "js1",
    staticClass: "table table-condensed table-bordered table-striped",
    attrs: {
      "name": "js1",
      "id": "js1"
    }
  }, [_vm._m(4), _vm._v(" "), _c('thead', _vm._l((_vm.executadasparcial), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "justificativa-meta"
    }, [_vm._v("\n                    " + _vm._s(data.meta) + " "), _c('span', {
      staticClass: "justificativa-atividade"
    }, [_c('b', [_vm._v(_vm._s(data.atividade))])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group required",
      class: {
        'has-error': _vm.errors.first('metaMotivo' + data.id)
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.motivo),
        expression: "data.motivo"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      class: {
        'has-error': _vm.errors.first('metaMotivo' + data.id)
      },
      attrs: {
        "name": 'metaMotivo' + data.id,
        "rows": "7",
        "cols": "5",
        "type": "text",
        "minlength": "1",
        "id": data.motivo + data.id,
        "disabled": _vm.ehVisualizacao
      },
      domProps: {
        "value": (data.motivo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(data, "motivo", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group required",
      class: {
        'has-error': _vm.errors.first('metaProvidencia' + data.id)
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.providencia),
        expression: "data.providencia"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control form-group required",
      class: {
        'has-error': _vm.errors.first('metaProvidencia' + data.id)
      },
      attrs: {
        "name": 'metaProvidencia' + data.id,
        "rows": "7",
        "cols": "5",
        "type": "text",
        "minlength": "1",
        "id": data.providencia + data.id,
        "disabled": _vm.ehVisualizacao
      },
      domProps: {
        "value": (data.providencia)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(data, "providencia", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('datepicker', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      class: {
        'has-error': _vm.errors.first('metaPrazo_regularizacao' + data.id)
      },
      attrs: {
        "type": "date",
        "name": 'metaPrazo_regularizacao' + data.id,
        "disabled": _vm.ehVisualizacao,
        "input-class": "form-control datepicker",
        "language": _vm.$datePickerPtBR,
        "maxlength": "20",
        "use-utc": true,
        "placeholder": "__ /__ /____",
        "format": "dd/MM/yyyy"
      },
      model: {
        value: (data.prazo_regularizacao_meta),
        callback: function($$v) {
          _vm.$set(data, "prazo_regularizacao_meta", $$v)
        },
        expression: "data.prazo_regularizacao_meta"
      }
    })], 1)])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.naoexecutadas.length) ? _c('table', {
    ref: "js2",
    staticClass: "table table-condensed table-bordered table-striped",
    attrs: {
      "name": "js2",
      "id": "js2"
    }
  }, [_vm._m(5), _vm._v(" "), _c('thead', _vm._l((_vm.naoexecutadas), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.meta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.atividade))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group required",
      class: {
        'has-error': _vm.errors.first('dataMotivo' + data.id)
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.motivo),
        expression: "data.motivo"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      class: {
        'has-error': _vm.errors.first('dataMotivo' + data.id)
      },
      attrs: {
        "name": 'dataMotivo' + data.id,
        "rows": "8",
        "cols": "6",
        "type": "text",
        "minlength": "1",
        "id": data.motivo + data.id,
        "disabled": _vm.ehVisualizacao
      },
      domProps: {
        "value": (data.motivo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(data, "motivo", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group required",
      class: {
        'has-error': _vm.errors.first('dataProvidencia' + data.id)
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.providencia),
        expression: "data.providencia"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      class: {
        'has-error': _vm.errors.first('dataProvidencia' + data.id)
      },
      attrs: {
        "name": 'dataProvidencia' + data.id,
        "rows": "8",
        "cols": "5",
        "type": "text",
        "minlength": "1",
        "id": data.providencia + data.id,
        "disabled": _vm.ehVisualizacao
      },
      domProps: {
        "value": (data.providencia)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(data, "providencia", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group required",
      class: {
        'has-error': _vm.errors.first('metaPrazo_regularizacao1' + data.id)
      }
    }, [_c('datepicker', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      class: {
        'has-error': _vm.errors.first('metaPrazo_regularizacao1' + data.id)
      },
      attrs: {
        "type": "date",
        "name": 'metaPrazo_regularizacao1' + data.id,
        "disabled": _vm.ehVisualizacao,
        "input-class": "form-control datepicker",
        "language": _vm.$datePickerPtBR,
        "maxlength": "20",
        "use-utc": true,
        "placeholder": "__ /__ /____",
        "startDate": "1900-01-01",
        "format": "dd/MM/yyyy"
      },
      model: {
        value: (data.prazo_regularizacao_atividade),
        callback: function($$v) {
          _vm.$set(data, "prazo_regularizacao_atividade", $$v)
        },
        expression: "data.prazo_regularizacao_atividade"
      }
    })], 1)])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('visualiza-gantt', {
    attrs: {
      "numeroProjeto": _vm._.has(_vm.$route.params.row, 'item') ? _vm.$route.params.row.item.numero : !_vm._.isEmpty(_vm.$route.params.row.projeto) ? _vm.$route.params.row.projeto.substring(0, 5) : '',
      "tipoBarra": 'declarado',
      "mostrarExecFinanc": false,
      "mostrarExecDeclarada": true
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box box-default"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table b-table table-hover table-bordered b-table-stacked-md"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Participantes")]), _c('td', {
    staticClass: "centro"
  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.participantes))]), _c('td', {
    staticClass: "centro"
  }, [_vm._v(_vm._s(_vm.totalizadoresListaParticipantes.participantes))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Jovens")]), _c('td', {
    staticClass: "centro"
  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.jovens))]), _c('td', {
    staticClass: "centro"
  }, [_vm._v(_vm._s(_vm.totalizadoresListaParticipantes.jovens))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Mulheres")]), _c('td', {
    staticClass: "centro"
  }, [_vm._v(_vm._s(_vm.previstoPublicoAlvo.mulheres))]), _c('td', {
    staticClass: "centro"
  }, [_vm._v(_vm._s(_vm.totalizadoresListaParticipantes.mulheres))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "box-header with-border col form-group required"
  }, [_c('h3', {
    staticClass: "box-title control-label"
  }, [_vm._v(" Lista de Participantes: "), _c('label', {
    staticClass: "control-label"
  }, [_c('font', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v("*")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('listaParticipantes', {
    attrs: {
      "propsParticipantes": _vm.telaRelatorio.numero_participantes.lista_participantes,
      "disable": _vm.desabilitar,
      "propsRelatorio": _vm.telaRelatorio,
      "usuarioLogado": _vm.tipoUsu,
      "idRelatorio": this.$route.params.row.item.id,
      "idProposta": this.proposta.id
    },
    on: {
      "participantesAdicionado": function($event) {
        _vm.telaRelatorio.numero_participantes.lista_participantes = $event
      },
      "totalizadores": function($event) {
        _vm.totalizadoresListaParticipantes = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col form-group required"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.consideracoes_gerais.valor),
      expression: "telaRelatorio.consideracoes_gerais.valor"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": 'Relate fatos relativos às metas e atividades, não contemplados no relatório, que você julgar importante para compreensão da situação atual do projeto',
      "name": "dsConsGerais",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.telaRelatorio.consideracoes_gerais.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.consideracoes_gerais, "valor", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('execCronograma')
    }
  }, [_c('div', {
    staticClass: "col form-group required"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("O cronograma físico-financeiro está sendo executado conforme previsto?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-2 form-group required"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cronograma_conforme_previsto.resposta),
      expression: "telaRelatorio.cronograma_conforme_previsto.resposta"
    }],
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "type": "radio",
      "name": "execCronograma",
      "value": "SIM"
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.cronograma_conforme_previsto.resposta, "SIM")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.cronograma_conforme_previsto, "resposta", "SIM")
      }
    }
  }), _vm._v(" Sim\n                              "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cronograma_conforme_previsto.resposta),
      expression: "telaRelatorio.cronograma_conforme_previsto.resposta"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.ehVisualizacao,
      "name": "execCronograma",
      "value": "NAO"
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.cronograma_conforme_previsto.resposta, "NAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.cronograma_conforme_previsto, "resposta", "NAO")
      }
    }
  }), _vm._v(" Não\n                              "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]), _vm._v(" "), (_vm.telaRelatorio.cronograma_conforme_previsto.resposta === 'NAO') ? _c('div', [_c('div', {
    staticClass: "col-md-12 form-group required",
    class: {
      'has-error': _vm.errors.first('justificativaCronograma')
    }
  }, [_c('label', {
    staticClass: "form-group control-label",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px",
      "font-size": "12px"
    }
  }, [_vm._v("Justifique")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.cronograma_conforme_previsto.justificativa),
      expression: "telaRelatorio.cronograma_conforme_previsto.justificativa"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "name": "justificativaCronograma"
    },
    domProps: {
      "value": (_vm.telaRelatorio.cronograma_conforme_previsto.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.cronograma_conforme_previsto, "justificativa", $event.target.value)
      }
    }
  })])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border form-group required"
  }, [_c('h3', {
    staticClass: "box-title control-label"
  }, [_vm._v("Contrapartida (em " + _vm._s(this.formataData(this.$route.params.row.item.apresentado_em)) + "):")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped text-center"
  }, [_vm._m(9), _vm._v(" "), _c('thead', _vm._l((_vm.contrapartida), function(contra) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(contra.item) + " - " + _vm._s(contra.item_descricao))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(contra.orcado))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(contra.realizado))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(contra.atingimento))])])
  }), 0)])])]), _vm._v(" "), (_vm.tipoUsu === 'FUNDACAO') ? _c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border form-group required"
  }, [_c('h3', {
    staticClass: "box-title control-label"
  }, [_vm._v("Contrapartida (em " + _vm._s(this.formataData(new Date)) + "):")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped text-center"
  }, [_vm._m(10), _vm._v(" "), _vm._l((this.atividadesProposta), function(atividade) {
    return (!this.loadingProposta) ? _c('thead', _vm._l((atividade.itens_orcamentos), function(item) {
      return (item.origem == 2) ? _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v("(" + _vm._s(item.item.ds_type) + ") " + _vm._s(item.item.ds_code) + " - " + _vm._s(item.item.ds_description))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v("R$ " + _vm._s(_vm._f("decimal2")(item.valorOrcado)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v("R$ " + _vm._s(_vm._f("decimal2")(item.valorSaldo)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("percentage")(item.percAtingimento)))])]) : _vm._e()
    }), 0) : _vm._e()
  })], 2), _vm._v(" "), (this.loadingProposta) ? _c('div', {
    staticClass: "contrapartida-loading"
  }, [_vm._v("\n                  carregando... "), _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col control-label "
  }, [_vm._v(" a) A contrapartida está sendo comprovada de acordo com o previsto no Plano de Trabalho?")]), _vm._v(" "), _c('div', {
    staticClass: "col form-group required-field",
    class: {
      'has-error': _vm.errors.first('enumContApr')
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta),
      expression: "telaRelatorio.contrapartida_comprovada_previsto.resposta"
    }],
    attrs: {
      "type": "radio",
      "name": "enumContApr",
      "value": "SIM",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta, "SIM")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.contrapartida_comprovada_previsto, "resposta", "SIM")
      }
    }
  }), _vm._v(" Sim\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta),
      expression: "telaRelatorio.contrapartida_comprovada_previsto.resposta"
    }],
    attrs: {
      "type": "radio",
      "name": "enumContApr",
      "value": "NAO",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta, "NAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.contrapartida_comprovada_previsto, "resposta", "NAO")
      }
    }
  }), _vm._v(" Não\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta),
      expression: "telaRelatorio.contrapartida_comprovada_previsto.resposta"
    }],
    attrs: {
      "type": "radio",
      "name": "enumContApr",
      "value": "PARCIALMENTE",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta, "PARCIALMENTE")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.contrapartida_comprovada_previsto, "resposta", "PARCIALMENTE")
      }
    }
  }), _vm._v(" Parcialmente\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.first('enumContApr')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Comprovação de contrapartida é obrigatório')))]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.contrapartida_comprovada_previsto.resposta !== 'SIM') ? _c('div', [_c('div', {
    staticClass: "col form-group required",
    class: {
      'has-error': _vm.errors.first('justContra')
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px",
      "font-size": "12px"
    }
  }, [_vm._v("Justifique")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.contrapartida_comprovada_previsto.justificativa),
      expression: "telaRelatorio.contrapartida_comprovada_previsto.justificativa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "name": "justContra",
      "id": "justContra",
      "rows": "7",
      "cols": "5"
    },
    domProps: {
      "value": (_vm.telaRelatorio.contrapartida_comprovada_previsto.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.contrapartida_comprovada_previsto, "justificativa", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justContra')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Número de participantes é obrigatório')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "col control-label",
    attrs: {
      "for": "telaRelatorio.comprovantes_enviados_fbb.resposta"
    }
  }, [_vm._v("b) Os comprovantes disponíveis foram enviados à Fundação BB?")]), _vm._v(" "), _c('div', {
    staticClass: "col form-group required",
    class: {
      'has-error': _vm.errors.first('contCompr')
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comprovantes_enviados_fbb.resposta),
      expression: "telaRelatorio.comprovantes_enviados_fbb.resposta"
    }],
    attrs: {
      "type": "radio",
      "name": "contCompr",
      "value": "SIM",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.comprovantes_enviados_fbb.resposta, "SIM")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.comprovantes_enviados_fbb, "resposta", "SIM")
      }
    }
  }), _vm._v(" Sim\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comprovantes_enviados_fbb.resposta),
      expression: "telaRelatorio.comprovantes_enviados_fbb.resposta"
    }],
    attrs: {
      "type": "radio",
      "name": "contCompr",
      "value": "NAO",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.comprovantes_enviados_fbb.resposta, "NAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.comprovantes_enviados_fbb, "resposta", "NAO")
      }
    }
  }), _vm._v(" Não\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.first('contCompr')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Comprovantes disponíveis é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default required"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col form-group required-field",
    class: {
      'has-error': _vm.errors.first('justDivulgacao')
    }
  }, [_c('label', {
    staticClass: "control-label required"
  }, [_vm._v("Descrição das ações:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.acoes_divulgacao_prevista.justificativa),
      expression: "telaRelatorio.acoes_divulgacao_prevista.justificativa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "required": "",
      "name": "justDivulgacao"
    },
    domProps: {
      "value": (_vm.telaRelatorio.acoes_divulgacao_prevista.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.acoes_divulgacao_prevista, "justificativa", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justDivulgacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Divulgações realizadas é obrigatório')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group required",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "box-body required-field",
    class: {
      'has-error': _vm.errors.first('comercializacao')
    },
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("O Projeto contribui para a Comercialização da Produção?")]), _vm._v(" "), _c('h5', [_vm._v("Caso a resposta tenha sido \"SIM\" marque abaixo o(os) canal(is) utilizado(os);")]), _vm._v(" "), _c('h5', [_vm._v("Caso a resposta tenha sido \"NÃO\" justifique;")]), _vm._v(" "), _c('h5', [_vm._v("Caso não esteja prevista a comercialização de produtos do empreendimento, marque a opção \"NÃO SE APLICA\".")]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.resposta),
      expression: "telaRelatorio.comercializacao_producao.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "value": "SIM",
      "disabled": _vm.ehVisualizacao,
      "name": "comercializacao",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.comercializacao_producao.resposta, "SIM")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.comercializacao_producao, "resposta", "SIM")
      }
    }
  }), _vm._v(" Sim\n                    "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.resposta),
      expression: "telaRelatorio.comercializacao_producao.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "value": "NAO",
      "disabled": _vm.ehVisualizacao,
      "name": "comercializacao",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.comercializacao_producao.resposta, "NAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.comercializacao_producao, "resposta", "NAO")
      }
    }
  }), _vm._v(" Não\n                    "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.resposta),
      expression: "telaRelatorio.comercializacao_producao.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "value": "NAO-SE-APLICA",
      "disabled": _vm.ehVisualizacao,
      "name": "comercializacao",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.comercializacao_producao.resposta, "NAO-SE-APLICA")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.comercializacao_producao, "resposta", "NAO-SE-APLICA")
      }
    }
  }), _vm._v(" Não se aplica\n                    "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errors.first('comercializacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Comercialização é obrigatório')))]) : _vm._e()]), _vm._v(" "), (_vm.telaRelatorio.comercializacao_producao.resposta === 'SIM') ? _c('div', {
    staticClass: "col-md-12 form-group required-field",
    staticStyle: {
      "display": "inline-grid",
      "margin-top": "10px"
    }
  }, [_c('div', {
    ref: "com",
    staticClass: "col-md-8 required-field",
    class: {
      'has-error': _vm.errors.first('acao')
    },
    attrs: {
      "id": "com"
    }
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade),
      expression: "telaRelatorio.comercializacao_producao.canal.venda_na_propriedade"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ehVisualizacao,
      "false-value": 'NAO',
      "true-value": 'SIM',
      "name": "acao"
    },
    domProps: {
      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade, 'SIM')
    },
    on: {
      "click": function($event) {
        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
      },
      "change": function($event) {
        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.venda_na_propriedade,
          $$el = $event.target,
          $$c = $$el.checked ? ('SIM') : ('NAO');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "venda_na_propriedade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "venda_na_propriedade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "venda_na_propriedade", $$c)
        }
      }
    }
  }), _vm._v("Venda na Propriedade\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor),
      expression: "telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ehVisualizacao,
      "false-value": 'NAO',
      "true-value": 'SIM'
    },
    domProps: {
      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor, 'SIM')
    },
    on: {
      "click": function($event) {
        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
      },
      "change": function($event) {
        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.direto_ao_consumidor,
          $$el = $event.target,
          $$c = $$el.checked ? ('SIM') : ('NAO');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "direto_ao_consumidor", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "direto_ao_consumidor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "direto_ao_consumidor", $$c)
        }
      }
    }
  }), _vm._v("Direito ao Consumidor\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa),
      expression: "telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ehVisualizacao,
      "false-value": 'NAO',
      "true-value": 'SIM'
    },
    domProps: {
      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa, 'SIM')
    },
    on: {
      "change": function($event) {
        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.programa_de_aquisição_de_alimentos_paa,
          $$el = $event.target,
          $$c = $$el.checked ? ('SIM') : ('NAO');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_de_aquisição_de_alimentos_paa", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_de_aquisição_de_alimentos_paa", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_de_aquisição_de_alimentos_paa", $$c)
        }
      }
    }
  }), _vm._v("Programa de Aquisição de Alimentos - PAA\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.canal.feiras_livres),
      expression: "telaRelatorio.comercializacao_producao.canal.feiras_livres"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ehVisualizacao,
      "false-value": 'NAO',
      "true-value": 'SIM'
    },
    domProps: {
      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.feiras_livres) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.feiras_livres, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.feiras_livres, 'SIM')
    },
    on: {
      "click": function($event) {
        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
      },
      "change": function($event) {
        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.feiras_livres,
          $$el = $event.target,
          $$c = $$el.checked ? ('SIM') : ('NAO');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_livres", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_livres", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_livres", $$c)
        }
      }
    }
  }), _vm._v("Feiras Livres\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox",
    staticStyle: {
      "margin-left": "69px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.canal.mercadinhos),
      expression: "telaRelatorio.comercializacao_producao.canal.mercadinhos"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ehVisualizacao,
      "false-value": 'NAO',
      "true-value": 'SIM'
    },
    domProps: {
      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.mercadinhos) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.mercadinhos, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.mercadinhos, 'SIM')
    },
    on: {
      "click": function($event) {
        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
      },
      "change": function($event) {
        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.mercadinhos,
          $$el = $event.target,
          $$c = $$el.checked ? ('SIM') : ('NAO');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "mercadinhos", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "mercadinhos", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "mercadinhos", $$c)
        }
      }
    }
  }), _vm._v("Mercadinhos\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox",
    staticStyle: {
      "margin-left": "68px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae),
      expression: "telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ehVisualizacao,
      "false-value": 'NAO',
      "true-value": 'SIM'
    },
    domProps: {
      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae, 'SIM')
    },
    on: {
      "click": function($event) {
        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
      },
      "change": function($event) {
        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.programa_nacional_de_alimentação_escolar_pnae,
          $$el = $event.target,
          $$c = $$el.checked ? ('SIM') : ('NAO');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_nacional_de_alimentação_escolar_pnae", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_nacional_de_alimentação_escolar_pnae", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "programa_nacional_de_alimentação_escolar_pnae", $$c)
        }
      }
    }
  }), _vm._v("Programa Nacional de Alimentação Escolar -PNAE\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas),
      expression: "telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ehVisualizacao,
      "false-value": 'NAO',
      "true-value": 'SIM'
    },
    domProps: {
      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas, 'SIM')
    },
    on: {
      "click": function($event) {
        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
      },
      "change": function($event) {
        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.feiras_agroecológicas,
          $$el = $event.target,
          $$c = $$el.checked ? ('SIM') : ('NAO');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_agroecológicas", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_agroecológicas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "feiras_agroecológicas", $$c)
        }
      }
    }
  }), _vm._v("Feiras Agroecológicas\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox",
    staticStyle: {
      "margin-left": "13px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.canal.atravessadores),
      expression: "telaRelatorio.comercializacao_producao.canal.atravessadores"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ehVisualizacao,
      "false-value": 'NAO',
      "true-value": 'SIM'
    },
    domProps: {
      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.atravessadores) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.atravessadores, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.atravessadores, 'SIM')
    },
    on: {
      "click": function($event) {
        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
      },
      "change": function($event) {
        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.atravessadores,
          $$el = $event.target,
          $$c = $$el.checked ? ('SIM') : ('NAO');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "atravessadores", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "atravessadores", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "atravessadores", $$c)
        }
      }
    }
  }), _vm._v("Atravessadores\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox",
    staticStyle: {
      "margin-left": "55px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização),
      expression: "telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ehVisualizacao,
      "false-value": 'NAO',
      "true-value": 'SIM'
    },
    domProps: {
      "checked": Array.isArray(_vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização) ? _vm._i(_vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização, null) > -1 : _vm._q(_vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização, 'SIM')
    },
    on: {
      "click": function($event) {
        return _vm.mudaEstilo(_vm.telaRelatorio.comercializacao_producao.canal)
      },
      "change": function($event) {
        var $$a = _vm.telaRelatorio.comercializacao_producao.canal.outros_canais_de_comercialização,
          $$el = $event.target,
          $$c = $$el.checked ? ('SIM') : ('NAO');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "outros_canais_de_comercialização", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "outros_canais_de_comercialização", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.telaRelatorio.comercializacao_producao.canal, "outros_canais_de_comercialização", $$c)
        }
      }
    }
  }), _vm._v("Outros canais de comercialização\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.comercializacao_producao.resposta === 'NAO') ? _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('considera1')
    }
  }, [_c('h5', {
    staticClass: "control-label"
  }, [_vm._v("Considerações :")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.comercializacao_producao.justificativa),
      expression: "telaRelatorio.comercializacao_producao.justificativa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "considera1",
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "considera1",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.telaRelatorio.comercializacao_producao.justificativa)
    },
    on: {
      "change": _vm.mudaEstilo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.comercializacao_producao, "justificativa", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 ",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-solid box-default required"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "box box-default form-group required",
    class: {
      'has-error': _vm.errors.first('questao1')
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('questao1')
    },
    staticStyle: {
      "padding-top": "1px"
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
      expression: "telaRelatorio.questionario.questao_1.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao1",
      "value": "1",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "1")
      }
    }
  }), _vm._v(" 1\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
      expression: "telaRelatorio.questionario.questao_1.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao1",
      "value": "2",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "2")
      }
    }
  }), _vm._v(" 2\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
      expression: "telaRelatorio.questionario.questao_1.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao1",
      "value": "3",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "3")
      }
    }
  }), _vm._v(" 3\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
      expression: "telaRelatorio.questionario.questao_1.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao1",
      "value": "4",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "4")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "4")
      }
    }
  }), _vm._v(" 4\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_1.resposta),
      expression: "telaRelatorio.questionario.questao_1.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao1",
      "value": "5",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_1.resposta, "5")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_1, "resposta", "5")
      }
    }
  }), _vm._v(" 5\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('consideracaoQ1')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_1.consideracoes),
      expression: "telaRelatorio.questionario.questao_1.consideracoes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": 'Comente sobre as ações desenvolvidas visando o aprimoramento e/ou o desenvolvimento de novas capacidades.',
      "name": "consideracaoQ1",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.telaRelatorio.questionario.questao_1.consideracoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.questionario.questao_1, "consideracoes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box box-default required"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('questao2')
    },
    staticStyle: {
      "padding-top": "1px"
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
      expression: "telaRelatorio.questionario.questao_2.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao2",
      "value": "1",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "1")
      }
    }
  }), _vm._v(" 1\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
      expression: "telaRelatorio.questionario.questao_2.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao2",
      "value": "2",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "2")
      }
    }
  }), _vm._v(" 2\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
      expression: "telaRelatorio.questionario.questao_2.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao2",
      "value": "3",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "3")
      }
    }
  }), _vm._v(" 3\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
      expression: "telaRelatorio.questionario.questao_2.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao2",
      "value": "4",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "4")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "4")
      }
    }
  }), _vm._v(" 4\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_2.resposta),
      expression: "telaRelatorio.questionario.questao_2.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao2",
      "value": "5",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_2.resposta, "5")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_2, "resposta", "5")
      }
    }
  }), _vm._v(" 5\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('consideracaoQ2')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_2.consideracoes),
      expression: "telaRelatorio.questionario.questao_2.consideracoes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": 'Comente sobre as ações desenvolvidas que contribuem para o protagonismo de mulheres e jovens ou relate sobre as dificuldades encontradas.',
      "name": "consideracaoQ2",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.telaRelatorio.questionario.questao_2.consideracoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.questionario.questao_2, "consideracoes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box box-default required"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('questao3')
    },
    staticStyle: {
      "padding-top": "1px"
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
      expression: "telaRelatorio.questionario.questao_3.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao3",
      "value": "1",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "1")
      }
    }
  }), _vm._v(" 1\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
      expression: "telaRelatorio.questionario.questao_3.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao3",
      "value": "2",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "2")
      }
    }
  }), _vm._v(" 2\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
      expression: "telaRelatorio.questionario.questao_3.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao3",
      "value": "3",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "3")
      }
    }
  }), _vm._v(" 3\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
      expression: "telaRelatorio.questionario.questao_3.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao3",
      "value": "4",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "4")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "4")
      }
    }
  }), _vm._v(" 4\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_3.resposta),
      expression: "telaRelatorio.questionario.questao_3.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao3",
      "value": "5",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_3.resposta, "5")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_3, "resposta", "5")
      }
    }
  }), _vm._v(" 5\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('consideracaoQ3')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_3.consideracoes),
      expression: "telaRelatorio.questionario.questao_3.consideracoes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": 'Comente sobre as ações desenvolvidas visando novas parcerias ou relate sobre as dificuldades encontradas',
      "name": "consideracaoQ3",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.telaRelatorio.questionario.questao_3.consideracoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.questionario.questao_3, "consideracoes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box box-default required"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('questao4')
    },
    staticStyle: {
      "padding-top": "1px"
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
      expression: "telaRelatorio.questionario.questao_4.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao4",
      "value": "1",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "1")
      }
    }
  }), _vm._v(" 1\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
      expression: "telaRelatorio.questionario.questao_4.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao4",
      "value": "2",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "2")
      }
    }
  }), _vm._v(" 2\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
      expression: "telaRelatorio.questionario.questao_4.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao4",
      "value": "3",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "3")
      }
    }
  }), _vm._v(" 3\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
      expression: "telaRelatorio.questionario.questao_4.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao4",
      "value": "4",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "4")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "4")
      }
    }
  }), _vm._v(" 4\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_4.resposta),
      expression: "telaRelatorio.questionario.questao_4.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao4",
      "value": "5",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_4.resposta, "5")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_4, "resposta", "5")
      }
    }
  }), _vm._v(" 5\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('consideracaoQ4')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_4.consideracoes),
      expression: "telaRelatorio.questionario.questao_4.consideracoes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": 'Comente sobre as novas oportunidades, a quantidade de pessoas e as áreas de atuação, ou relate as dificuldades.',
      "name": "consideracaoQ4",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.telaRelatorio.questionario.questao_4.consideracoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.questionario.questao_4, "consideracoes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box box-default required"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required-field",
    class: {
      'has-error': _vm.errors.first('questao5')
    },
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
      expression: "telaRelatorio.questionario.questao_5.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao5",
      "value": "1",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "1")
      }
    }
  }), _vm._v(" 1\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
      expression: "telaRelatorio.questionario.questao_5.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao5",
      "value": "2",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "2")
      }
    }
  }), _vm._v(" 2\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
      expression: "telaRelatorio.questionario.questao_5.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao5",
      "value": "3",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "3")
      }
    }
  }), _vm._v(" 3\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
      expression: "telaRelatorio.questionario.questao_5.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao5",
      "value": "4",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "4")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "4")
      }
    }
  }), _vm._v(" 4\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_5.resposta),
      expression: "telaRelatorio.questionario.questao_5.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao5",
      "value": "5",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_5.resposta, "5")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_5, "resposta", "5")
      }
    }
  }), _vm._v(" 5\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group",
    class: {
      'has-error': _vm.errors.first('consideracaoQ5')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_5.consideracoes),
      expression: "telaRelatorio.questionario.questao_5.consideracoes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": 'Comente sobre as práticas adotadas e os resultados alcançados, ou relate as dificuldades',
      "name": "consideracaoQ5",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.telaRelatorio.questionario.questao_5.consideracoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.questionario.questao_5, "consideracoes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box box-default required"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required-field",
    class: {
      'has-error': _vm.errors.first('questao6')
    },
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
      expression: "telaRelatorio.questionario.questao_6.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao6",
      "value": "1",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "1")
      }
    }
  }), _vm._v(" 1\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
      expression: "telaRelatorio.questionario.questao_6.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao6",
      "value": "2",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "2")
      }
    }
  }), _vm._v(" 2\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
      expression: "telaRelatorio.questionario.questao_6.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao6",
      "value": "3",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "3")
      }
    }
  }), _vm._v(" 3\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
      expression: "telaRelatorio.questionario.questao_6.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao6",
      "value": "4",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "4")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "4")
      }
    }
  }), _vm._v(" 4\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_6.resposta),
      expression: "telaRelatorio.questionario.questao_6.resposta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "questao6",
      "value": "5",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.questionario.questao_6.resposta, "5")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio.questionario.questao_6, "resposta", "5")
      }
    }
  }), _vm._v(" 5\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required",
    class: {
      'has-error': _vm.errors.first('consideracaoQ6')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.questionario.questao_6.consideracoes),
      expression: "telaRelatorio.questionario.questao_6.consideracoes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": 'Comente sobre as ações realizadas contra a discriminação, desigualdade de gênero, trabalho escravo ou infantil, exploração sexual, etc, ou relate as dificuldades encontradas.',
      "name": "consideracaoQ6",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.telaRelatorio.questionario.questao_6.consideracoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.questionario.questao_6, "consideracoes", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_vm._m(20), _vm._v(" "), (_vm.telaRelatorio.objeto_convenio.valor.length > 0) ? _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label col"
  }, [_vm._v(_vm._s(_vm.telaRelatorio.objeto_convenio.valor))])]) : _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label col"
  }, [_vm._v("Objeto não cadastrado")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 required",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default required-field"
  }, [_c('div', {
    staticClass: "box-header with-border form-group required-field"
  }, [_c('h3', {
    staticClass: "box-title control-label"
  }, [_vm._v("Informar como está o desenvolvimento do Objeto do Convênio: "), _c('label', [_c('font', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v("*")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col form-group required",
    class: {
      'has-error': _vm.errors.first('objetoConvenioTexto')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.desenvolvimento_objeto_convenio.valor),
      expression: "telaRelatorio.desenvolvimento_objeto_convenio.valor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "objetoConvenioTexto",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "value": (_vm.telaRelatorio.desenvolvimento_objeto_convenio.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.desenvolvimento_objeto_convenio, "valor", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border form-group required"
  }, [_c('h3', {
    staticClass: "box-title control-label"
  }, [_vm._v("Informar sobre o alcance dos Objetivos do projeto:"), _c('label', [_c('font', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v(" *")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped text-center"
  }, [_vm._m(21), _vm._v(" "), _c('thead', _vm._l((_vm.telaRelatorio.objetivos_projeto.row), function(objProj) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "data-title": "'Item'",
        "sortable": "'item'",
        "width": "20%"
      }
    }, [_vm._v(_vm._s(objProj.item))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "data-title": "'Descrição'",
        "sortable": "'description'",
        "width": "40%"
      }
    }, [_vm._v(_vm._s(objProj.descricao))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "'Realizado'",
        "sortable": "'realizado'",
        "width": "40%"
      }
    }, [_c('div', {
      staticClass: "form-group required",
      class: {
        'has-error': _vm.errors.first('descRealizado')
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (objProj.realizado),
        expression: "objProj.realizado"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "descRealizado",
        "disabled": _vm.ehVisualizacao,
        "rows": "5",
        "cols": "5",
        "type": "text",
        "minlength": "1",
        "required": ""
      },
      domProps: {
        "value": (objProj.realizado)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(objProj, "realizado", $event.target.value)
        }
      }
    })])])])
  }), 0), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.telaRelatorio.objetivos_projeto.row.length === 0)),
      expression: "(telaRelatorio.objetivos_projeto.row.length === 0)"
    }]
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("Nenhum registro encontrado!")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border form-group required"
  }, [_c('h3', {
    staticClass: "box-title control-label"
  }, [_vm._v("Resultados alcançados até o momento:"), _c('label', [_c('font', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v(" *")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col form-group required",
    class: {
      'has-error': _vm.errors.first('dsResultado')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.resultados_alcancados.valor),
      expression: "telaRelatorio.resultados_alcancados.valor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": 'Informar os benefícios aos participantes que já podem ser mensurados.',
      "name": "dsResultado",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "value": (_vm.telaRelatorio.resultados_alcancados.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.resultados_alcancados, "valor", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border form-group required"
  }, [_c('h3', {
    staticClass: "box-title control-label"
  }, [_vm._v("Depoimentos:"), _c('label', [_c('font', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v(" *")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col form-group required",
    class: {
      'has-error': _vm.errors.first('dsDepoimentos')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.depoimentos.valor),
      expression: "telaRelatorio.depoimentos.valor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": 'Insira aqui depoimentos sobre os resultados e impactos do projeto, outros aspectos considerados relevantes, prestados por beneficiários, parceiros ou membros da equipe responsável pelo projeto. Esses depoimentos (ou trechos) poderão ser utilizados pela Fundação para divulgação interna e externa.',
      "name": "dsDepoimentos",
      "disabled": _vm.ehVisualizacao,
      "required": ""
    },
    domProps: {
      "value": (_vm.telaRelatorio.depoimentos.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.depoimentos, "valor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Modelos de documentos:")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.urlLaravel + '/docs/modelo_cursos_e_capacitacoes.xls',
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cursos e Capacitações")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.urlLaravel + '/docs/modelo_relacao_de_bens.doc',
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Relação de Bens")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.urlLaravel + '/docs/modelo_termo_de_designacao.docx'
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Termo de Designação")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.urlLaravel + '/docs/modelo_termo_de_recebimento_de_obra_civil.docx'
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Termo de Recebimento de Obra Civil")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Anexos diversos:\n                        "), (!_vm.ehVisualizacao) ? _c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-style": "italic",
      "margin-left": "10px",
      "color": "var(--cor-atencao-dark)"
    }
  }, [_vm._v("Obrigatório anexar e informar data de vigência dos documentos: CNEP/CEPIM e CNDT")]) : _vm._e()]), _vm._v(" "), (_vm.ehVisualizacao) ? _c('div', [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.telaRelatorio.anexos_diversos.row,
      "documentTypes": '',
      "disable": 'true',
      "localUso": _vm.listaDocDiversos,
      "salvouOK": _vm.salvouOK
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('div', [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.telaRelatorio.anexos_diversos.row,
      "documentTypes": '',
      "disable": '',
      "localUso": _vm.listaDocDiversos,
      "salvouOK": _vm.salvouOK
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.tipoUsu === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("Histórico:")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped text-center"
  }, [_vm._m(22), _vm._v(" "), _c('thead', _vm._l((_vm.historicoRelatorio), function(hist) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(hist.etapa))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(hist.concluído_em))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(hist.justificativa))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(hist.usuário))])])
  }), 0)])])])]) : _vm._e()])])]), _vm._v(" "), ((_vm.tipoUsu === 'FUNDACAO' && _vm.sit === 'VALIDAR') || _vm.ehVisualizacao) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.tipoUsu === 'FUNDACAO') ? _c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group required",
    class: {
      'has-error': _vm.errors.first('conclusao')
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.resultadoAprovacao),
      expression: "telaRelatorio.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "conclusao",
      "value": "APROVADO",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.resultadoAprovacao, "APROVADO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.telaRelatorio, "resultadoAprovacao", "APROVADO")
      }
    }
  }), _vm._v(" Aprovar\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.resultadoAprovacao),
      expression: "telaRelatorio.resultadoAprovacao"
    }],
    attrs: {
      "type": "radio",
      "name": "conclusao",
      "value": "REVISAO",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.telaRelatorio.resultadoAprovacao, "REVISAO")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.telaRelatorio, "resultadoAprovacao", "REVISAO")
      }, _vm.atualizaComponente]
    }
  }), _vm._v(" Enviar para Revisão\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]), _vm._v(" "), (_vm.telaRelatorio.resultadoAprovacao != undefined && _vm.telaRelatorio.resultadoAprovacao != 'APROVADO') ? _c('div', {
    staticClass: "col-md-12 form-group required",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', {
    staticClass: "col control-label",
    attrs: {
      "uib-tooltip": "Informe aqui as considerações da decisão acima"
    }
  }, [_vm._v("Considerações (para a entidade)")]), _vm._v(" "), _c('em', {
    staticClass: "text-light"
  }, [_vm._v(" (Limitado a 2.000 caracteres)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.justificativa_devolucao.valor),
      expression: "telaRelatorio.justificativa_devolucao.valor"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "maxlength": "2000",
      "name": "dsReportApr",
      "required": ""
    },
    domProps: {
      "value": (_vm.telaRelatorio.justificativa_devolucao.valor)
    },
    on: {
      "keyup": _vm.countdown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.justificativa_devolucao, "valor", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-right text-small",
    class: {
      'text-danger': _vm.hasError
    }
  }, [_vm._v(_vm._s(_vm.remainingCount))])]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.resultadoAprovacao === 'APROVADO' && _vm.telaRelatorio.resultadoAprovacao != undefined) ? _c('div', {
    staticClass: "col-md-12 form-group required",
    class: {
      'has-error': _vm.errors.first('dsObsFbb')
    },
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', {
    staticClass: "col control-label",
    attrs: {
      "uib-tooltip": "Informe aqui as considerações da decisão acima"
    }
  }, [_vm._v("Parecer Fundação BB:"), _c('font', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v(" *")])], 1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telaRelatorio.parecer_fbb.valor),
      expression: "telaRelatorio.parecer_fbb.valor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "dsObsFbb",
      "maxlength": "700",
      "placeholder": 'Insira seu parecer elencando as dificuldades e suas causas, destaques positivos quanto às metas e aos resultados e outros aspectos considerados relevantes',
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.telaRelatorio.parecer_fbb.valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.telaRelatorio.parecer_fbb, "valor", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.telaRelatorio.resultadoAprovacao === 'APROVADO' && _vm.telaRelatorio.resultadoAprovacao != undefined && _vm.tipoUsu === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "indicadores-cb-inline"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n                        Há restrição em:\n                        "), _c('div', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [(_vm.ehVisualizacao) ? _c('i', {
    class: _vm.telaRelatorio.encaminhamento_restricao_cepim === 'NAO' ? 'fa fa-square-o' : 'fa fa-check-square-o',
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  }) : _c('i', {
    class: _vm.telaRelatorio.encaminhamento_restricao_cepim === 'SIM' ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o',
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.telaRelatorio.encaminhamento_restricao_cepim = (_vm.telaRelatorio.encaminhamento_restricao_cepim === 'SIM' ? 'NAO' : 'SIM')
      }
    }
  }), _vm._v("\n                          CNEP/CEPIM\n                        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [(_vm.ehVisualizacao) ? _c('i', {
    class: _vm.telaRelatorio.encaminhamento_restricao_cndt === 'NAO' ? 'fa fa-square-o' : 'fa fa-check-square-o',
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  }) : _c('i', {
    class: _vm.telaRelatorio.encaminhamento_restricao_cndt === 'SIM' ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o',
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.telaRelatorio.encaminhamento_restricao_cndt = (_vm.telaRelatorio.encaminhamento_restricao_cndt === 'SIM' ? 'NAO' : 'SIM')
      }
    }
  }), _vm._v("\n                          CNDT\n                        ")]), _vm._v(" "), (!_vm.ehVisualizacao && (_vm.telaRelatorio.encaminhamento_restricao_cepim === 'SIM' || _vm.telaRelatorio.encaminhamento_restricao_cndt === 'SIM')) ? _c('div', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_c('label', {
    staticClass: "label label-warning"
  }, [_vm._v("Será encaminhado e-mail, registrada a anotação 2422 - Certidão com restrição e aberto chamado para acompanhamento da ocorrência")])]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(25), _vm._v(" "), (_vm.tipoUsu === 'FUNDACAO' && (_vm.telaRelatorio.resultadoAprovacao === 'APROVADO' || _vm.telaRelatorio.resultadoAprovacao === 'REVISAO')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Registrar ocorrência no projeto referente à análise do relatório:\n                          "), (_vm.telaRelatorio.resultadoAprovacao === 'REVISAO') ? _c('span', [_vm._v("Revisão")]) : _vm._e(), _vm._v(" "), (_vm.telaRelatorio.resultadoAprovacao === 'APROVADO') ? _c('span', [_vm._v("Aprovado")]) : _vm._e()])]), _vm._v(" "), (_vm.loading.projetoEntidadeOcorrencia || _vm.loading.listaOcorrencias) ? _c('span', [_vm._m(26)]) : _c('span', [(_vm._.isEmpty(_vm.ocorrenciaEditando)) ? _c('div', {}, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.novaOcorrencia($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova Ocorrência")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "centralizado"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Código")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Observação")]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Ação")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.telaRelatorio.ocorrencias.length > 0) ? _vm._l((_vm.telaRelatorio.ocorrencias), function(ocorrencia, idx) {
    return _c('tr', [_c('td', {
      staticClass: "text-bold centralizado",
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(ocorrencia.id))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_c('div', {
      staticClass: "truncar",
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("\n                                      " + _vm._s(ocorrencia.enquadramento.codigo) + " - " + _vm._s(ocorrencia.enquadramento.descricao) + "\n                                    ")])]), _vm._v(" "), _c('td', {
      staticClass: "centralizado",
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(ocorrencia.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ocorrencia.observacao))]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('td', {
      staticClass: "centralizado",
      staticStyle: {
        "width": "170px"
      }
    }, [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editaOcorrencia(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.excluiOcorrencia(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _vm._e()])
  }) : [_vm._m(27)]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  })]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.ocorrenciaEditando)) ? _c('div', {
    staticClass: "col-md-12 well"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrenciaEditando.tipo),
      expression: "ocorrenciaEditando.tipo"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoOcorrencia",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": 'PROJETO',
      "checked": _vm._q(_vm.ocorrenciaEditando.tipo, 'PROJETO')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrenciaEditando, "tipo", 'PROJETO')
      }
    }
  }), _vm._v(" Projeto\n                                "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ocorrenciaEditando.tipo),
      expression: "ocorrenciaEditando.tipo"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoOcorrencia",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": 'ENTIDADE',
      "checked": _vm._q(_vm.ocorrenciaEditando.tipo, 'ENTIDADE')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.ocorrenciaEditando, "tipo", 'ENTIDADE')
      }
    }
  }), _vm._v(" Entidade\n                                "), _c('span', {
    staticClass: "pull-right text-blue"
  }, [(_vm.ocorrenciaEditando.tipo === 'PROJETO') ? _c('span', [_vm._v(" Essa ocorrência será registrada no projeto "), _c('strong', [_vm._v(_vm._s(_vm.telaRelatorio.cabecalho.numero_projeto))])]) : _vm._e(), _vm._v(" "), (_vm.ocorrenciaEditando.tipo === 'ENTIDADE') ? _c('span', [_vm._v(" Essa ocorrência será registrada na entidade "), _c('strong', [_vm._v(_vm._s(_vm.telaRelatorio.cabecalho.entidade))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('codigo_ocorrencia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Código:")]), _vm._v(" "), (_vm.loading.listaOcorrencias) ? _c('div', {
    staticClass: "col-md-10"
  }, [_vm._m(28)]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm._.orderBy(_vm._.filter(_vm.listaTiposOcorrencias, function(o) {
        return o.criar === 1 && o.automatico === 0 && _vm._.includes((_vm.ocorrenciaEditando.tipo === 'PROJETO' ? ['1', '2', '3'] : ['1', '2', '4']), ('' + o.codigo).substr(0, 1))
      }), ['codigo'], ['asc']),
      "custom-label": function (option) {
        return ("" + (option.codigo + ' ' + option.descricao))
      },
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "track-by": "codigo",
      "placeholder": "Selecione uma ocorrência",
      "name": "codigo_ocorrencia"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('strong', [_vm._v(_vm._s(props.option.codigo))]), _vm._v(" " + _vm._s(props.option.descricao))]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "truncar"
        }, [_c('span', {
          staticClass: "identificadorIDProjeto"
        }, [_vm._v(_vm._s(props.option.codigo))]), _vm._v(" " + _vm._s(props.option.descricao))])]
      }
    }], null, false, 1494732627),
    model: {
      value: (_vm.ocorrenciaEditando.enquadramento),
      callback: function($$v) {
        _vm.$set(_vm.ocorrenciaEditando, "enquadramento", $$v)
      },
      expression: "ocorrenciaEditando.enquadramento"
    }
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('codigo_ocorrencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve selecionar o código da ocorrência desejada na lista")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('descricao_ocorrencia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Informe o detalhamento da situação que gerou a ocorrência",
      "name": "descricao_ocorrencia",
      "id": "descricao_ocorrencia",
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.ocorrenciaEditando.observacao),
      callback: function($$v) {
        _vm.$set(_vm.ocorrenciaEditando, "observacao", $$v)
      },
      expression: "ocorrenciaEditando.observacao"
    }
  }), _vm._v(" "), (_vm.errors.first('descricao_ocorrencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Informe o quê se refere essa ocorrência")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.loading.listaOcorrencias && !_vm._.isEmpty(_vm.ocorrenciaEditando.enquadramento) && !_vm._.isEmpty(_vm.ocorrenciaEditando.observacao)) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.okOcorrencia
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelaOcorrencia
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])]) : _vm._e()])]) : _vm._e()])])]) : _vm._e()]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuário que enviou o relatório")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dados do projeto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col form-group required"
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v("O objeto foi cumprido?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border form-group required"
  }, [_c('h3', {
    staticClass: "box-title control-label"
  }, [_vm._v("Metas e Atividades")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#BBDEFB"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation fa-3",
    staticStyle: {
      "color": "blue",
      "margin-left": "10px",
      "font-size": "large",
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Justificativa pelo não atingimento de meta")])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Meta")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Motivo")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Providências")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Prazo para regularização")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#FFCDD2"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation fa-3",
    staticStyle: {
      "color": "red",
      "margin-left": "10px",
      "font-size": "large",
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Justificativa pela não execução da atividade")])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Meta")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Atividade")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Motivo")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Providências")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Prazo para regularização")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(" Público-alvo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Publico")]), _c('th', {
    staticClass: "centro"
  }, [_vm._v("Previsto")]), _c('th', {
    staticClass: "centro"
  }, [_vm._v("Realizado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Considerações:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Item")]), _vm._v(" "), _c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Realizado")]), _vm._v(" "), _c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Atingimento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Item")]), _vm._v(" "), _c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Saldo")]), _vm._v(" "), _c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Atingimento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border form-group required"
  }, [_c('h3', {
    staticClass: "box-title control-label"
  }, [_vm._v("Quais foram as ações de divulgação realizadas no Projeto?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Sustentabilidade do Projeto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border required"
  }, [_c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("RESPONDA AS QUESTÕES ABAIXO ATRIBUINDO A SEGUINTE ESCALA DE PONTUAÇÃO:")])]), _vm._v(" "), _c('h5', {
    staticClass: "control-label",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("(1) Nem um Pouco (2) Um Pouco (3) Razoavelmente (4) Bastante (5) Totalmente")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border form-group required-field",
    staticStyle: {
      "background-color": "#F2F3F4"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                        O Projeto contribui para o desenvolvimento de novos conhecimentos/habilidades?\n                      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border form-group required-field",
    staticStyle: {
      "background-color": "#F2F3F4"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                        O Projeto contribui para o envolvimento de mulheres e jovens?\n                      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border form-group required-field",
    staticStyle: {
      "background-color": "#F2F3F4"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("O Projeto contribui para a formação de novas parcerias além da Fundação Banco do Brasil?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border form-group required-field",
    staticStyle: {
      "background-color": "#F2F3F4"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("O Projeto contribui para o surgimento de novas oportunidades de trabalho e/ou renda?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border form-group required",
    staticStyle: {
      "background-color": "#F2F3F4"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("O Projeto contribui para a preservação do meio ambiente e o cuidado ambiental?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border form-group required",
    staticStyle: {
      "background-color": "#F2F3F4"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("O Projeto contribui para a valorização de questões relativas a direitos humanos?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Objeto do Convênio:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#F2F3F4"
    }
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Item")]), _vm._v(" "), _c('th', {
    staticClass: "centro",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
    staticClass: "centro control-label",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Realizado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Nome da Tarefa")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Data da execução da tarefa")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Justificativa em caso de devolução")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Usuário que executou a tarefa")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h6', {
    staticClass: "box-title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Conclusão do relatório")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Encaminhamentos:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando dados de projeto, entidade e lista de ocorrências...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Nenhuma ocorrência para ser gerada!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando lista de ocorrências...")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a601cb3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/EditaRelExec.vue
// module id = 1912
// module chunks = 2